/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { komboGetJobs } from '../../axios/komboGetJobs'
import type {
	KomboGetJobsError,
	KomboGetJobsPathParams,
	KomboGetJobsQueryParams,
	KomboGetJobsResponse,
} from '../../types/KomboGetJobs'

export const komboGetJobsQueryKey = (id: KomboGetJobsPathParams['id'], params?: KomboGetJobsQueryParams) =>
	[{ url: '/export-integrations/integrations/:id/jobs', params: { id } }, ...(params ? [params] : [])] as const

export type KomboGetJobsQueryKey = ReturnType<typeof komboGetJobsQueryKey>

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/KomboController.php KomboController::getJobs */
export function komboGetJobsQueryOptions(
	id: KomboGetJobsPathParams['id'],
	params?: KomboGetJobsQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		KomboGetJobsResponse,
		AxiosError<KomboGetJobsError>,
		KomboGetJobsResponse,
		KomboGetJobsQueryKey
	>({
		queryKey: komboGetJobsQueryKey(id, params),
		queryFn: ({ signal }) => komboGetJobs(id, params, { signal, ...config }).then(res => res.data),
		enabled: !!id,
	})
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/KomboController.php KomboController::getJobs */
export function useKomboGetJobs<TSelectData = KomboGetJobsResponse>(
	id: KomboGetJobsPathParams['id'],
	params?: KomboGetJobsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<KomboGetJobsResponse, AxiosError<KomboGetJobsError>, TSelectData, KomboGetJobsQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<KomboGetJobsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...komboGetJobsQueryOptions(id, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/KomboController.php KomboController::getJobs */
export function useKomboGetJobsSuspense<TSelectData = KomboGetJobsResponse>(
	id: KomboGetJobsPathParams['id'],
	params?: KomboGetJobsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					KomboGetJobsResponse,
					AxiosError<KomboGetJobsError>,
					TSelectData,
					KomboGetJobsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<KomboGetJobsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...komboGetJobsQueryOptions(id, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
